exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "legend[data-v-00a1f134] {\n  font-size: 1rem;\n}\n.is-invalid .invalid-feedback[data-v-00a1f134] {\n  display: block;\n}\n.table th[data-v-00a1f134],\n.table td[data-v-00a1f134] {\n  white-space: nowrap;\n  font-size: small;\n}\n", ""]);

// exports
